module.exports = __webpack_public_path__ + "img/filter.56b4e496.svg";